import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, renderList as _renderList, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 9,
  class: "flex justify-start"
}
const _hoisted_2 = {
  key: 13,
  class: "flex justify-start"
}
const _hoisted_3 = {
  key: 0,
  class: "text-xs font-medium px-3 py-1 rounded flex items-center justify-center bg-gray-200 text-black"
}
const _hoisted_4 = {
  key: 14,
  class: "flex justify-start"
}
const _hoisted_5 = {
  key: 0,
  class: "text-xs font-medium px-3 py-1 rounded flex items-center justify-center bg-gray-200 text-black"
}
const _hoisted_6 = {
  key: 0,
  class: "w-5 h-5 flex items-center justify-center rounded-full bg-green-500 p-2"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check text-white" }, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 1,
  class: "w-5 h-5 flex items-center justify-center rounded-full bg-red-500 p-2"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times text-white" }, null, -1)
const _hoisted_11 = [
  _hoisted_10
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_delivery_table_row_actions = _resolveComponent("delivery-table-row-actions")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_cheap = _resolveComponent("cheap")!
  const _component_delivery_cargo_status = _resolveComponent("delivery-cargo-status")!

  return (_ctx.column.key === 'actions')
    ? (_openBlock(), _createBlock(_component_delivery_table_row_actions, {
        key: 0,
        row: _ctx.row,
        onPayment: _ctx.emitPayment,
        onWaitList: _ctx.emitWaitList
      }, null, 8, ["row", "onPayment", "onWaitList"]))
    : (_ctx.column.key === 'index')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createTextVNode(_toDisplayString(_ctx.index + 1), 1)
        ], 64))
      : (_ctx.column.key === 'orderNumber')
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 2,
            class: "text-blue-500",
            to: `/order/${_ctx.row.orderId}`,
            target: "_blank"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.row.orderNumber), 1)
            ]),
            _: 1
          }, 8, ["to"]))
        : (_ctx.column.key === 'deliveredAt')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              _createTextVNode(_toDisplayString(_ctx.formatDateWithTimeFromBackend(_ctx.row.deliveredAt)), 1)
            ], 64))
          : (_ctx.column.key === 'changedTakeDateAt')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                _createTextVNode(_toDisplayString(_ctx.formatDateWithTimeFromBackend(_ctx.row.changedTakeDateAt)), 1)
              ], 64))
            : (_ctx.column.key === 'createdAt')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                  _createTextVNode(_toDisplayString(_ctx.formatDateWithTimeFromBackend(_ctx.row.createdAt)), 1)
                ], 64))
              : (_ctx.column.key === 'problems')
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 6 }, _renderList(_ctx.row.problems, (pb, i) => {
                    return (_openBlock(), _createBlock(_component_cheap, {
                      key: `pb-${i}`,
                      class: "w-max small mb-2"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(pb), 1)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                : (_ctx.column.key === 'invoiceNumber')
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 7,
                      class: "text-blue-500",
                      to: `/invoice/${_ctx.row.invoiceId}`,
                      target: "_blank"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.row.invoiceNumber), 1)
                      ]),
                      _: 1
                    }, 8, ["to"]))
                  : (_ctx.column.key === 'changedTakeDateAt')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 8 }, [
                        _createTextVNode(_toDisplayString(_ctx.row.status && _ctx.row.status.id === 27 ? _ctx.row.changedTakeDateAt : '-'), 1)
                      ], 64))
                    : (_ctx.column.key === 'status')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                          (_ctx.row.status)
                            ? (_openBlock(), _createBlock(_component_delivery_cargo_status, {
                                key: 0,
                                status: _ctx.row.status
                              }, null, 8, ["status"]))
                            : _createCommentVNode("", true)
                        ]))
                      : (_ctx.column.key === 'customerSector')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 10 }, [
                            (_ctx.row.customer && _ctx.row.customer.sector)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode(_toDisplayString(_ctx.row.customer.sector.name), 1)
                                ], 64))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode(" - ")
                                ], 64))
                          ], 64))
                        : (_ctx.column.key === 'customerAddress')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 11 }, [
                              (_ctx.row.customer)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode(_toDisplayString(_ctx.row.customer.shortAddress), 1)
                                  ], 64))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createTextVNode(" - ")
                                  ], 64))
                            ], 64))
                          : (_ctx.column.key === 'courier')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 12 }, [
                                (_ctx.row.courier)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createTextVNode(_toDisplayString(_ctx.row.courier.fullName), 1)
                                    ], 64))
                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _createTextVNode(" - ")
                                    ], 64))
                              ], 64))
                            : (_ctx.column.key === 'waitList')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                  (_ctx.row.waitList && _ctx.row.waitList.status)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.row.waitList.status.name), 1))
                                    : _createCommentVNode("", true)
                                ]))
                              : (_ctx.column.key === 'waitListComment')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                    (_ctx.row.waitList && _ctx.row.waitList.comment)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.row.waitList.comment), 1))
                                      : _createCommentVNode("", true)
                                  ]))
                                : (_ctx.isWaitListId)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 15 }, [
                                      (_ctx.row.waitList.state.id === 48)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
                                        : (_ctx.row.waitList.state.id === 49)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
                                          : _createCommentVNode("", true)
                                    ], 64))
                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 16 }, [
                                      _createTextVNode(_toDisplayString(_ctx.row[_ctx.column.key]), 1)
                                    ], 64))
}